// export const SortBy = <TData>(key: FunctionKey<TData>, order: OrderType = 'asc') => {
//   return (a: TData, b: TData) => {
//     const valueA = typeof key === 'function' ? key(a) : a[key];
//     const valueB = typeof key === 'function' ? key(b) : b[key];
//     const lowerA = typeof valueA === 'string' ? valueA.toLowerCase() : (valueA as number);
//     const lowerB = typeof valueB === 'string' ? valueB.toLowerCase() : (valueB as number);
//     if (order === 'asc') {
//       return lowerA > lowerB ? 1 : lowerA < lowerB ? -1 : 0;
//     } else {
//       return lowerA < lowerB ? 1 : lowerA > lowerB ? -1 : 0;
//     }
//   };
// };
export const SortByLocaleCompare = (key, order = 'asc') => {
    return (a, b) => {
        var _a, _b;
        const valueA = typeof key === 'function' ? key(a) : a[key];
        const valueB = typeof key === 'function' ? key(b) : b[key];
        const lowerA = (_a = (typeof valueA === 'string' ? valueA.toLowerCase() : valueA === null || valueA === void 0 ? void 0 : valueA.toString())) !== null && _a !== void 0 ? _a : '';
        const lowerB = (_b = (typeof valueB === 'string' ? valueB.toLowerCase() : valueB === null || valueB === void 0 ? void 0 : valueB.toString())) !== null && _b !== void 0 ? _b : '';
        if (order === 'asc') {
            return lowerA.localeCompare(lowerB);
        }
        else {
            return lowerB.localeCompare(lowerA);
        }
    };
};
// export const MultiSortBy = <TData>(keys: FunctionKey<TData>[], orders: OrderType[]) => {
//   return (a: TData, b: TData) => {
//     for (let i = 0; i < keys.length; i++) {
//       const key = keys[i];
//       const order = orders[i];
//       const valueA = typeof key === 'function' ? key(a) : a[key];
//       const valueB = typeof key === 'function' ? key(b) : b[key];
//       const lowerA = typeof valueA === 'string' ? valueA.toLowerCase() : (valueA as number);
//       const lowerB = typeof valueB === 'string' ? valueB.toLowerCase() : (valueB as number);
//       if (order === 'desc') {
//         return lowerA > lowerB ? 1 : lowerA < lowerB ? -1 : 0;
//       } else {
//         return lowerA > lowerB ? 1 : lowerA < lowerB ? -1 : 0;
//       }
//     }
//     return 0;
//   };
// };
